import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export const exportToExcelProductPromo = async (data) => {
    // Mengonversi data dengan nama field baru
    let mappedData = [];

    data.forEach((item, index) => {
        mappedData.push({
            'No': index + 1,
            'Nama Barang': item.product_name,
            'Harga Normal': item.price_normal,
            'Diskon 1 (%)': item.discount_percent,
            'Diskon 2 (%)': item.discount_percent_2,
            'Harga Jual': item.price_sale,
        });
    });

    // Membuat worksheet Excel
    const worksheet = XLSX.utils.json_to_sheet(mappedData);

    // Membuat workbook dan menyimpan sebagai file Excel
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(blob, 'produk_promo.xlsx');
};

export const exportToExcelProductPrice = async (outlet, data) => {

    // Header Outlet (Label Only)
    let outletRows = [
        ["DAFTAR HARGA PRODUK"],
        ["Daftar Outlet:"]
    ];

    outlet.forEach((o, index) => {
        outletRows.push([`${index + 1}. ${o.label}`]);
    });

    outletRows.push([""]); // spasi sebelum tabel

    // Map Data Produk
    let mappedData = [];
    data.forEach((item, index) => {
        mappedData.push({
            'No': index + 1,
            'Kode Barang': item.product_code,
            'Nama Barang': item.product_name,
            'Harga Normal': item.price_normal,
            'Diskon 1 (%)': item.discount_percent,
            'Diskon 2 (%)': item.discount_percent_2,
            'Harga Jual': item.price_sale,
        });
    });

    const worksheet = XLSX.utils.json_to_sheet(mappedData, { origin: "A" + (outlet.length + 4) });

    // Inject Title & Outlet List
    XLSX.utils.sheet_add_aoa(worksheet, outletRows, { origin: "A1" });

    // Set Column Width
    worksheet['!cols'] = [
        { wch: 5 },
        { wch: 15 },
        { wch: 35 },
        { wch: 15 },
        { wch: 12 },
        { wch: 12 },
        { wch: 15 }
    ];

    // Merge Judul
    worksheet['!merges'] = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: 6 } }
    ];

    // Style Title
    worksheet['A1'].s = {
        font: { bold: true, sz: 16 },
        alignment: { horizontal: "center" }
    };

    // Row header product
    const startHeaderRow = outlet.length + 3;
    const range = XLSX.utils.decode_range(worksheet['!ref']);

    // Style Header Border + Bold
    for (let C = 0; C <= range.e.c; C++) {
        const cellAddress = XLSX.utils.encode_cell({ r: startHeaderRow, c: C });
        if (worksheet[cellAddress]) {
            worksheet[cellAddress].s = {
                font: { bold: true },
                alignment: { horizontal: "center" },
                border: { top: { style: "thin" }, left: { style: "thin" }, right: { style: "thin" }, bottom: { style: "thin" } }
            };
        }
    }

    // Style Border untuk semua baris barang
    for (let R = startHeaderRow + 1; R <= range.e.r; R++) {
        for (let C = 0; C <= range.e.c; C++) {
            let cell = worksheet[XLSX.utils.encode_cell({ r: R, c: C })];
            if (cell) {
                cell.s = {
                    border: {
                        top: { style: "thin" },
                        left: { style: "thin" },
                        right: { style: "thin" },
                        bottom: { style: "thin" }
                    }
                };
            }
        }
    }

    // Generate File Excel
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Daftar Harga');
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    saveAs(new Blob([excelBuffer]), `daftar_harga_outlet.xlsx`);
};

export const exportToExcelProductPromoNotUploaded = async (data) => {

    const mappedData = data.map((item, index) => ({
        'No': index + 1,
        'Kode Barang': item.kode_produk_excel || '',
        'Nama Barang': item.nama_produk_excel || '',
        'Harga Normal': item.harga_normal || 0,
        'Diskon 1 (%)': item.diskon_1 || 0,
        'Diskon 2 (%)': item.diskon_2 || 0,
        'Harga Jual': item.harga_jual || 0,
        'Alasan Gagal': item.reason || ''
    }));

    const worksheet = XLSX.utils.json_to_sheet(mappedData);

    worksheet['!cols'] = [
        { wch: 5 },
        { wch: 20 },
        { wch: 50 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
        { wch: 50 },
    ];

    const range = XLSX.utils.decode_range(worksheet['!ref']);

    // Header Style
    for (let C = range.s.c; C <= range.e.c; C++) {
        const address = XLSX.utils.encode_cell({ r: 0, c: C });

        if (worksheet[address]) {
            worksheet[address].s = {
                font: {
                    bold: true,
                    color: { rgb: "FFFFFF" }
                },
                fill: {
                    fgColor: { rgb: "4472C4" }
                },
                alignment: {
                    horizontal: "center",
                    vertical: "center"
                },
                border: {
                    top: { style: "thin" },
                    bottom: { style: "thin" },
                    left: { style: "thin" },
                    right: { style: "thin" }
                }
            };
        }
    }

    // Body Style
    for (let R = 1; R <= range.e.r; R++) {
        for (let C = range.s.c; C <= range.e.c; C++) {
            const address = XLSX.utils.encode_cell({ r: R, c: C });

            if (worksheet[address]) {
                worksheet[address].s = {
                    border: {
                        top: { style: "thin" },
                        bottom: { style: "thin" },
                        left: { style: "thin" },
                        right: { style: "thin" }
                    },
                    alignment: {
                        vertical: "center"
                    }
                };
            }
        }
    }

    // Highlight kolom Alasan Gagal
    for (let R = 1; R <= range.e.r; R++) {
        const address = XLSX.utils.encode_cell({ r: R, c: 7 });

        if (worksheet[address]) {
            worksheet[address].s = {
                font: {
                    color: { rgb: "C00000" },
                    bold: true
                },
                fill: {
                    fgColor: { rgb: "FFF2CC" }
                },
                border: {
                    top: { style: "thin" },
                    bottom: { style: "thin" },
                    left: { style: "thin" },
                    right: { style: "thin" }
                }
            };
        }
    }

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        'Produk Tidak Terupload'
    );

    const excelBuffer = XLSX.write(workbook, {
        bookType: 'xlsx',
        type: 'array'
    });

    saveAs(
        new Blob([excelBuffer]),
        `produk_promo_tidak_terupload.xlsx`
    );
};